// Custom Vercel Web Analytics events.
// The site loads the tracking script manually (public/*.html <script src="/_vercel/insights/script.js">)
// rather than via the @vercel/analytics npm package, so custom events use the
// window.va() global directly, per Vercel's manual-setup docs.
// Safe no-op if analytics is disabled/blocked — never throws, never blocks the caller.

export function track(eventName, data) {
  try {
    if (typeof window !== 'undefined' && typeof window.va === 'function') {
      window.va('event', { name: eventName, data });
    }
  } catch (_) {
    // analytics must never break the app
  }
}
